module.exports = __webpack_public_path__ + "img/self-assessment.b13bdf62.svg";